import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const Benefits3D = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-list:first-of-type,for-hover:first-of-type{
                                padding-left:0!important
                            }
             .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4;
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
            
            `}</style>
      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Immersive visual appeal.</h3>
          <div className={' border-gray-dark border-r-0 md:border-r-1'}>
            <div className={'pr-0 md:pr-30'}>Create a visually stunning 3D animation and grab viewers' attention right away.</div>
          </div>
        </div>
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14  px-0 md:px-30 '}>A strong engagement tool.</h3>
          <div className={'w-full  border-gray-dark border-r-0 md:border-r-1'}>
            <div className={' px-0 md:px-30 '}>
              The depth of a 3D explainer video creates a sense of reality and boosts engaging viewing adventure.
            </div>
          </div>
        </div>
        <div className={'w-30p block pl-0 md:pl-30 pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Captivating storytelling.</h3>
          Weave a thrilling story by creating a detailed and realistic 3D image for the viewer.
        </div>
      </Slider>
    </>
  );
};
export default Benefits3D;
